import config from '@src/js/config';
import Alpine from 'alpinejs';
import { getAlpineStore } from '@src/js/utils/alpine-store';
import { AssistantService } from "@src/js/services/assistantService";
Alpine.data('assistants', () => ({
    assistants: [],
    newAssistant: {},
    deletionConfirmModal: {},
    creationAssistantModal: {},
    error: {},
    ready: false,
    async init() {
        this.deletionConfirmModal = { open: false, search: '', index: undefined };
        this.creationAssistantModal = { open: false, search: '', index: undefined };
        try {
            this.assistants = await AssistantService.getAll();
        }
        catch (err) {
            console.error('Failed to load assistants:', err);
            this.error.message = '❌ Failed to load assistants. Please try again later.';
        }
        this.ready = true;
    },
    async validateAndCreate() {
        this.error.message = '';
        try {
            const response = await fetch("https://api.openai.com/v1/assistants?limit=1", {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + this.newAssistant.openAIApiKey,
                    'Content-Type': 'application/json',
                    'OpenAI-Beta': 'assistants=v2'
                }
            });
            if (response.status === 200) {
                this.createAssistant();
            }
            else {
                this.error.message = '❌ Could not connect to OpenAI. Please check your API key.';
            }
        }
        catch (err) {
            console.error(err);
            this.error.message = '❌ Failed to validate API key.';
        }
    },
    async createAssistant() {
        const randomIndex = Math.floor(Math.random() * 9) + 1; // 1 to 9
        const randomImage = `/images/avatarIcons/av_${randomIndex}.svg`;
        this.newAssistant.imageUrl = randomImage;
        this.newAssistant.organisationId = getAlpineStore('user')?.organisationId;
        // get the user from the store
        console.log('Alpine.store("user")', Alpine.store('user'));
        try {
            const savedAssistant = await AssistantService.save(this.newAssistant);
            // Redirect to detail page
            window.location.href = `${config.APP_URL}assistants/assistant-detail.html?id=${savedAssistant._id}&key=${savedAssistant.shareKey}`;
        }
        catch (error) {
            console.error('Error saving assistant:', error);
            alert('Failed to create assistant: ' + (error.message || 'Unknown error'));
        }
    },
    confirmDelete(index) {
        this.deletionConfirmModal.index = index;
        this.deletionConfirmModal.open = true;
    },
    async deleteAssistant(index) {
        const assistant = this.assistants[index];
        console.log(assistant, 'Deleting assistant');
        try {
            await AssistantService.delete(assistant._id);
            this.assistants.splice(index, 1); // remove from UI list
        }
        catch (error) {
            console.error('Error deleting assistant:', error);
            alert('Failed to delete assistant: ' + (error.message || 'Unknown error'));
        }
        finally {
            this.deletionConfirmModal.open = false;
        }
    }
}));
